<template>
  <div class="modal__inner">
    <h2 class="smokeheadlineh2">{{ $t("settings") }}</h2>

    <p class="installHeadline">
      {{ $t(`languageselection_for_offline_usage_headline`) }}
    </p>

    <p class="paragraph__chooselang">
      {{ $t("settings_choose_language") }}
    </p>

    <p class="paragraph__chooselang">
      {{ $t("settings_choose_language_line_2") }}
    </p>

    <p class="paragraph__chooselang">
      {{ $t("settings_choose_language_line_3") }}
    </p>

    <div v-for="lang in allowedLanguages" :key="lang" class="checkmarkwrapper">
      <div>
        <CheckMark
          :value="chosenLanguages.includes(lang)"
          @input="chooseLanguage(lang)"
        />

        <p class="paragraph">{{ $t(`${lang}`) }}</p>
      </div>
    </div>
    <DownloadMenu
      :chosenLanguages="chosenLanguages"
      :downloadsPossible="downloadsPossible"
    />

    <div class="installGuideContainer">
      <p class="installHeadline">{{ $t(`install_headline`) }}</p>
      <div
        class="browserInstallGuide"
        v-for="browser in browserInstallData"
        :key="browser"
      >
        <p class="installGuideHeadline">
          {{ $t(browser.headline) }}
        </p>

        <p v-for="count in browser.steps" :key="count">
          {{ $t(browser.installStepTitle + count) }}
        </p>
      </div>
    </div>
    <div class="d-flex">
      <button
        class="button"
        @click="closeSettings"
        v-if="this.isntCachingOrDeleting"
      >
        <p>{{ $t("close") }}</p>
      </button>
    </div>
  </div>
</template>

<script>
import CheckMark from "./CheckMark";
import DownloadMenu from "./DownloadMenu";
import { deleteCachedElementsForLanguageInDB } from "@/services/caching/cachingHelpers.js";

export default {
  names: "Settings",
  components: {
    CheckMark,
    DownloadMenu
  },
  data() {
    return {
      allowedLanguages: ["de", "en"],
      chosenLanguages: [],
      browserInstallData: [
        {
          headline: "install_guide_headline_safari",
          steps: 3,
          installStepTitle: "install_steps_safari"
        },
        {
          headline: "install_guide_headline_chrome",
          steps: 2,
          installStepTitle: "install_steps_chrome"
        },
        {
          headline: "install_guide_headline_firefox",
          steps: 2,
          installStepTitle: "install_steps_firefox"
        }
      ]
    };
  },

  computed: {
    showProgress() {
      return this.$store.state.isDeletingElements;
    },
    allElementsCounts() {
      return this.$store.state.sumElementsToDelete;
    },
    loadedElements() {
      return this.$store.state.deletedElements;
    },
    checkMarkIcon() {
      return this.$store.getters.image_checkmarkicon_black;
    },
    isntCachingOrDeleting() {
      return (
        !this.$store.state.isCachingElements &&
        !this.$store.state.isDeletingElements
      );
    }
  },
  methods: {
    chooseLanguage(lang) {
      if (this.isntCachingOrDeleting) {
        if (this.chosenLanguages.includes(lang)) {
          this.chosenLanguages = this.chosenLanguages.filter(function(item) {
            return item !== lang;
          });
        } else {
          this.chosenLanguages.push(lang);
        }
      }
    },
    isLanguageNotCached(language) {
      return !this.$store.getters.isLanguageCached(language);
    },
    deleteElementsForLanguage(language) {
      deleteCachedElementsForLanguageInDB(language);
    },
    closeSettings() {
      this.$modal.hide("settings-modal");
    }
  },
  mounted() {
    if (this.$store.state.enIsCached) {
      this.chosenLanguages.push("en");
    }
    if (this.$store.state.deIsCached) {
      this.chosenLanguages.push("de");
    }
  }
};
</script>

<style scoped>
.smokeheadlineh2 {
  text-align: left;
  color: limegreen;
  margin-bottom: 1.5rem;
  font-family: Netto Bold, Open Sans, sans-serif;
}
.paragraph__chooselang {
  margin-bottom: 5px;
}
.paragraph__chooselang:last-of-type {
  margin-bottom: 1.5rem;
}
.checkmarkwrapper > * {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  margin-bottom: 10px;
}

.paragraph {
  margin-right: auto;
  margin-left: 20px;
}
.modal__inner {
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.button {
  margin-top: 1rem;
  margin-left: auto;
  color: #00aeef;
}

.trashicon:hover {
  color: gray;
}
img {
  height: 25px;
  width: 25px;
}
.installHeadline {
  font-family: Netto Bold, Open Sans, sans-serif;
  margin-bottom: 1.5rem;
}
.browserInstallGuide {
  margin-bottom: 1.5rem;
}
.installGuideHeadline {
  font-family: Netto Bold, Open Sans, sans-serif;
}

.installGuideContainer {
  padding-top: 2rem;
}
</style>
